import { render, staticRenderFns } from "./modalVerAnotacionSii.vue?vue&type=template&id=0a53c5bc&"
import script from "./modalVerAnotacionSii.vue?vue&type=script&lang=js&"
export * from "./modalVerAnotacionSii.vue?vue&type=script&lang=js&"
import style0 from "./modalVerAnotacionSii.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a53c5bc')) {
      api.createRecord('0a53c5bc', component.options)
    } else {
      api.reload('0a53c5bc', component.options)
    }
    module.hot.accept("./modalVerAnotacionSii.vue?vue&type=template&id=0a53c5bc&", function () {
      api.rerender('0a53c5bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/modales/modalVerAnotacionSii.vue"
export default component.exports